/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// =============================================================================
// Badge sutil para sinalizar o período do item (MANHA / TARDE).
// Cores intencionais: âmbar para manhã (sol nascente), azul para tarde.
// Mais leve que o ItemStatusBadge — texto só de marcador, não de status.
// =============================================================================

const PeriodPill = styled.span`
   display: inline-flex;
   align-items: center;
   justify-content: center;
   padding: ${({ $md }) => ($md ? '3px 10px' : '2px 8px')};
   border-radius: 999px;
   font-size: ${({ $md }) => ($md ? '12px' : '10px')};
   font-weight: 700;
   letter-spacing: ${({ $md }) => ($md ? '0.6px' : '0.3px')};
   background: ${({ $bg }) => $bg ?? 'rgba(0,0,0,0.06)'};
   color: ${({ $text }) => $text ?? '#444'};
`;

// Paleta padrão — sobre superfície clara (tabela, cards).
const PERIOD_CONFIG = {
   MANHA: {
      label: 'MANHÃ',
      bg: 'rgba(239,159,39,0.15)',
      text: '#854F0B',
   },
   TARDE: {
      label: 'TARDE',
      bg: 'rgba(55,138,221,0.12)',
      text: '#0C447C',
   },
};

// Paleta para fundo escuro (cabeçalho da ficha) — mais opaca e luminosa, pra
// não sumir contra o background app.
const PERIOD_CONFIG_ON_DARK = {
   MANHA: {
      bg: 'rgba(239,159,39,0.3)',
      text: '#ffcf87',
   },
   TARDE: {
      bg: 'rgba(55,138,221,0.35)',
      text: '#bcdcff',
   },
};

export default function PeriodBadge({ value, size = 'sm', onDark = false }) {
   const label = PERIOD_CONFIG[value]?.label ?? value ?? '—';
   const palette =
      (onDark ? PERIOD_CONFIG_ON_DARK[value] : PERIOD_CONFIG[value]) ?? {};

   return (
      <PeriodPill $md={size === 'md'} $bg={palette.bg} $text={palette.text}>
         {label}
      </PeriodPill>
   );
}

PeriodBadge.propTypes = {
   value: PropTypes.oneOf(['MANHA', 'TARDE']),
   size: PropTypes.oneOf(['sm', 'md']),
   onDark: PropTypes.bool,
};
